/**
 * Shared formatting utilities for the frontend.
 * Use these instead of defining local formatting functions in components.
 */

/** Format a number as Brazilian Real currency (R$ 1.234,56) */
export function formatCurrencyBRL(value: number): string {
  if (isNaN(value)) return "R$ 0,00";
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(value);
}

/** Format a CPF string: xxx.xxx.xxx-xx */
export function formatCPF(value: string): string {
  const numbers = value.replace(/\D/g, "");
  if (numbers.length <= 3) return numbers;
  if (numbers.length <= 6) return `${numbers.slice(0, 3)}.${numbers.slice(3)}`;
  if (numbers.length <= 9) return `${numbers.slice(0, 3)}.${numbers.slice(3, 6)}.${numbers.slice(6)}`;
  return `${numbers.slice(0, 3)}.${numbers.slice(3, 6)}.${numbers.slice(6, 9)}-${numbers.slice(9, 11)}`;
}

/** Format a CNPJ string: xx.xxx.xxx/xxxx-xx */
export function formatCNPJ(value: string): string {
  const numbers = value.replace(/\D/g, "");
  if (numbers.length <= 2) return numbers;
  if (numbers.length <= 5) return `${numbers.slice(0, 2)}.${numbers.slice(2)}`;
  if (numbers.length <= 8) return `${numbers.slice(0, 2)}.${numbers.slice(2, 5)}.${numbers.slice(5)}`;
  if (numbers.length <= 12)
    return `${numbers.slice(0, 2)}.${numbers.slice(2, 5)}.${numbers.slice(5, 8)}/${numbers.slice(8)}`;
  return `${numbers.slice(0, 2)}.${numbers.slice(2, 5)}.${numbers.slice(5, 8)}/${numbers.slice(8, 12)}-${numbers.slice(12, 14)}`;
}

/** Auto-format a PIX key based on digit count (CPF=11, CNPJ=14, otherwise passthrough) */
export function formatPIXKey(value: string): string {
  const numbers = value.replace(/\D/g, "");
  if (numbers.length === 11) return formatCPF(numbers);
  if (numbers.length === 14) return formatCNPJ(numbers);
  return value;
}
